import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoDestinatarioService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_destinatario {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_destinatario.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerDestinatariosSegunOrigen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
      query ($maq:maquinaInputType, $paginaActual:Int, $cantidadRegistrosxPagina:Int){
        tipo_destinatario {
          obtenerDestinatarios (
            maquina: $maq,
            paginaActual: $paginaActual,
            cantidadRegistrosPorPagina:$cantidadRegistrosxPagina
          ){
            respuesta {
              registros {
                codigo
                nombre
                descripcion

              }

            }

          }

        }
      }
      `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            console.log(response);
            const { mensajes, respuesta } = response.data.tipo_destinatario.obtenerDestinatarios;
            callback({ mensajes, respuesta });
        });
    }
}
TipoDestinatarioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoDestinatarioService_Factory() { return new TipoDestinatarioService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoDestinatarioService, providedIn: "root" });
